import React, { useCallback} from "react";
import { useDispatch } from "react-redux";

import { globalActions } from "../_actions";
import { UserDropdown } from "./UserDropdown";
import { EverouModulesActions } from "../_stores/ModulesStore/EverouModulesActions";
import { EVEROU_MODULE_IDS } from "../_constants";

export function WiredUserDropdown({
    user
}) {

    //LIBRARIES
    const dispatch = useDispatch();

    //ACTION HANDLERS
    const handleLogOut = useCallback(() => 
        dispatch(globalActions.showPopUpLogOut())
    , [dispatch]);

    const handleLogOutAll = useCallback(() =>
        dispatch(globalActions.showPopUpLogOutAll())
    , [dispatch]);

    const handleConnectedApps = useCallback(() =>
        dispatch(EverouModulesActions.selectModule(EVEROU_MODULE_IDS.CONNECTED_APPS))
    , [dispatch]);

    return (
        <UserDropdown {...{
            user,
            onConnectedApps: handleConnectedApps,
            onLogOut: handleLogOut,
            onLogOutAll: handleLogOutAll,
        }}/>
    );
}